// AdminLayout.jsx
import React from "react";
import Sidebar from "./admin/Sidebar";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { UserContext } from "./Context";

const AdminLayout = ({ children, user, isAuthenticated }) => {
  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return (
    <UserContext.Provider value={user}>
      <div dir="ltr" className="d-flex">
        <Sidebar />
        <main className="w-100" style={{ height: "100vh", overflow: "auto" }}>
          <div>{children}</div>
        </main>
      </div>
    </UserContext.Provider>
  );
};

export default AdminLayout;
